export default __webpack_public_path__ + "static/media/000_intro_part1.last.85fca3ec.png";